import React from 'react';

const About = () => {
  return (
    <div>
      <h1>About AI Web Accessibility Checker</h1>
      <p>Learn how our AI-powered tool can help you make your website more accessible.</p>
    </div>
  );
};

export default About;

